import {
  ACTION_GET,
  ACTION_PATCH,
  ACTION_POST,
  ACTION_PUT,
  BASE_URL,
  COUPON_DETAIL_BASE_URL,
  COUPON_WRITE_BASE_URL,
  BASE_USER_INFO_URL
} from "./config";
import { handleLogout } from "helpers/logout";

export const GET_DETAIL = () => {
  const url = `${COUPON_DETAIL_BASE_URL}/coupon/user/detail`;
  return new Promise((resolve, reject) => {
    ACTION_GET(url)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        handleError(error, reject);
      });
  });
};

export const GET_DETAIL_CARD = () => {
  const url = `${BASE_URL}/coupon/usercard/detail`;
  return new Promise((resolve, reject) => {
    ACTION_GET(url)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        handleError(error, reject);
      });
  });
};
export const GET_EXPIRED_COUPON = (params) => {
  const url = `${COUPON_WRITE_BASE_URL}/coupon/update/coupon/expiredate`;
  return new Promise((resolve, reject) => {
    ACTION_POST(url, params)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        handleError(error, reject);
      });
  });
};

export const GET_USER_INFO = () => {  
  const url = `${BASE_USER_INFO_URL}/userinfo`
  return new Promise((resolve, reject) => {
    ACTION_GET(url)
      .then((result) => {
        resolve(result)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export const POST_USER_INFO = (params = null) => {  
  const url = `${BASE_USER_INFO_URL}/userinfo`
  return new Promise((resolve, reject) => {
    ACTION_POST(url, params)
      .then((result) => {
        resolve(result)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export const VIP_REGISTER_EMAIL = (params) => {
  const url = `${BASE_URL}/coupon/email/registeration`;
  return new Promise((resolve, reject) => {
    ACTION_POST(url, params)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        handleError(error, reject);
      });
  });
};
export const VIP_USER_REGISTER = (params) => {
  const url = `${BASE_URL}/coupon/user/registeration`;
  return new Promise((resolve, reject) => {
    ACTION_POST(url, params)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        handleError(error, reject);
      });
  });
};

export const VIP_REGISTER_NAME = (params) => {
  const url = `${COUPON_WRITE_BASE_URL}/coupon/name/registeration`;
  return new Promise((resolve, reject) => {
    ACTION_POST(url, params)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        handleError(error, reject);
      });
  });
};
export const WITHDRAW_MEMBER = (params) => {  
  const url = `${COUPON_WRITE_BASE_URL}/coupon/user/withdraw`
  return new Promise((resolve, reject) => {
    ACTION_POST(url, params)
      .then((result) => {
        resolve(result)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export const SEND_EMAIL = (params) => {
  const url = `${BASE_URL}/send/email`;
  return new Promise((resolve, reject) => {
    ACTION_POST(url, params)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        handleError(error, reject);
      });
  });
};
export const VERIFY_EMAIL = (params) => {
  const url = `${BASE_URL}/verify/email`;
  return new Promise((resolve, reject) => {
    ACTION_POST(url, params)
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        handleError(error, reject);
      });
  });
};

export const INTEGRATE_LINE = () => {
  const url = `${process.env.REACT_APP_LOGIN_UPBOND_DOMAIN}/integrate-identities`;
  const redirectUrl = `${window.location.origin}/line/callback`;
  return new Promise((resolve, reject) => {
    ACTION_POST(url, {
      upstream: "line",
      client_id: process.env.REACT_APP_LINE_CLIENT_ID,
      redirect_url: redirectUrl,
    })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        handleError(error, reject);
      });
  });
};

const handleError = async (err, reject) => {  
  if (err?.code === 401) {
    await handleLogout();
  } else {
    reject(err);
  }
};
